import Vue from 'vue';
import shippingProviderTransformer from './../../transformers/shippingProvider';

const success = (resolve, response) => {
  resolve(shippingProviderTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(shippingProviderTransformer.fetch(errors));
};

export default shippingProvider => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/shipping_providers', shippingProvider)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/shippingProvider/store.js